export type SessionInvalidationReason = "jwt_expired" | "api_401";

type Listener = (reason: SessionInvalidationReason) => void;

const listeners = new Set<Listener>();

/** Cleared when a new session is saved so repeated invalidation can fire again. */
let invalidationSuppressed = false;

export function subscribeSessionInvalidation(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function emitSessionInvalidation(reason: SessionInvalidationReason): void {
  if (invalidationSuppressed) return;
  if (listeners.size === 0) return;
  invalidationSuppressed = true;
  for (const cb of [...listeners]) {
    try {
      cb(reason);
    } catch (e) {
      console.error("sessionInvalidation listener error:", e);
    }
  }
}

export function resetSessionInvalidationGate(): void {
  invalidationSuppressed = false;
}
